<template>
  <!-- eslint-disable vue/no-v-html -->
  <pre hidden v-html="metaData"></pre>
  <!-- eslint-enable -->
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { computed } from 'vue';

const envProps = useEnvProps();
const metaData = computed(() => {
  return JSON.stringify({ isNavMockHeader: envProps.isNavMockHeader, isNavMockFooter: envProps.isNavMockFooter, version: envProps.version }, null, 2);
});
</script>
